import axios from 'axios';
import _ from 'lodash';
import {
  apiErrorHandler,
  helperConvertApiRoute,
  helperGetApiHeaders,
  helperGetLiveUpNextUrl,
} from 'helpers/ApiHelper';
import { getAuthZEntitlementIssues } from 'helpers/ContentHelper';

export const CLEAR_BANNER_VIDEO = 'CLEAR_VIDEO';
const FETCH_BANNER_VIDEO = 'FETCH_BANNER_VIDEO';
export const FETCH_BANNER_VIDEO_UP_NEXT = 'FETCH_BANNER_VIDEO_UP_NEXT';
export const SET_BANNER_VIDEO = 'SET_BANNER_VIDEO';
export const SET_BANNER_VIDEO_ERROR = 'SET_BANNER_VIDEO_ERROR';

export function clearBannerVideo() {
  return {
    type: CLEAR_BANNER_VIDEO,
  };
}

function fetchVideo({ url, accessToken, deviceId }) {
  const pageType = 'videoDetail';
  const request = axios
    .get(
      helperConvertApiRoute(url),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_BANNER_VIDEO,
    payload: request,
  };
}

export function fetchUpNext({ upNextUrl, videoId, accessToken, deviceId }) {
  let url = upNextUrl;
  let pageType = 'videoDetail';
  if (!url && videoId) {
    const data = helperGetLiveUpNextUrl({ videoId });
    ({ url, pageType } = data);
  }
  const request = url
    ? axios
        .get(
          helperConvertApiRoute(url),
          helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
        )
        .catch(e => apiErrorHandler({ error: e }))
    : Promise.resolve();

  return {
    type: FETCH_BANNER_VIDEO_UP_NEXT,
    payload: request,
  };
}

function setError(errors) {
  return {
    type: SET_BANNER_VIDEO_ERROR,
    payload: errors,
  };
}

function setVideo(video) {
  return {
    type: SET_BANNER_VIDEO,
    payload: video,
  };
}

export function fetchBannerVideo({ url, accessToken, deviceId }) {
  return dispatch => {
    dispatch(fetchVideo({ url, accessToken, deviceId })).then(result => {
      const payload = _.get(result, 'payload');
      const response = _.get(payload, 'response');
      const entitlementIssues = getAuthZEntitlementIssues(response);
      const isEntitled = entitlementIssues ? !entitlementIssues.length : true;
      if (isEntitled) {
        const video = _.get(payload, 'data');
        dispatch(setVideo(video));
        const upNextUrl = _.get(video, 'upNextUrl');
        if (upNextUrl) dispatch(fetchUpNext({ upNextUrl, accessToken, deviceId }));
      } else {
        dispatch(setError(entitlementIssues));
      }
    });
  };
}
